<template>
  <!-- ボトムバー右端のリスクアセスメント操作。3相談画面（いつでも相談 / 夜間相談 / 日中助産師相談）で共有する。
       修正可能期限は Launcher が GET /new から受け取った値をそのまま表示し、期限計算をフロントに複製しない。 -->
  <div
    v-if="isPermitted"
    class="risk-assessment-bar-action"
  >
    <v-btn
      class="risk-assessment-bar-action__button"
      variant="outlined"
      color="#c8384f"
      :disabled="!editable"
      @click="$emit('open')"
    >
      リスクアセスメント入力
    </v-btn>
    <p
      v-if="editableUntilLabel"
      class="risk-assessment-bar-action__limit"
    >
      ＊{{ editableUntilLabel }} まで修正可能
    </p>
  </div>
</template>

<script>
import { canUseRiskAssessment } from "@/vue/entities/risk-assessment";
import { FEATURE_FLAGS } from "@/vue/shared/utils/featureFlags";

export default {
  name: "RiskAssessmentBarAction",
  props: {
    // 空文字のときは修正可能なアセスメントが無い状態。注記ごと非表示にする。
    editableUntilLabel: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["open"],
  computed: {
    // 許可ロール以外には導線自体を出さない（押しても 403 になるため / api-endpoints.md RBAC）。
    isPermitted() {
      // フラグB（#2599）有効時はボタンを出さない
      if (this.$store?.getters?.isFeatureEnabled?.(FEATURE_FLAGS.hideHighRiskBarActions) === true) return false;
      return canUseRiskAssessment(this.$store?.getters?.capabilities);
    }
  }
};
</script>

<style lang="scss" scoped>
// ボトムバーの高さは各画面のサイドバー高さ計算(calc(100vh - ...))が参照する固定値のため、
// 注記（修正可能期限）の有無でバーの高さを変えてはいけない。
// そこで注記は absolute でレイアウトから外し、バー下部の padding 内に描画する。
// このブロック自体の高さはボタン1個ぶん（高さ + 上下マージン）のままになるので、
// バーは align-items: center のままで他のボタンと上下が揃う。
.risk-assessment-bar-action {
  position: relative;
  // 他のボタン群とは種類の違う操作なので、バーの gap(12px) に加えて余白を足し、
  // ひとまとまりの操作群から視覚的に切り離す。
  margin-inline-start: 16px;
}

.risk-assessment-bar-action__button {
  height: 40px;
  background-color: #fff;
}

.risk-assessment-bar-action__limit {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  // ボタン下端とバー下端の間（既定 12px の padding）に収める。
  margin: -4px 0 0;
  font-size: 11px;
  line-height: 12px;
  color: #c8384f;
  white-space: nowrap;
  text-align: center;
}
</style>
